import type { Modifier } from '@dnd-kit/core'
import { useCallback } from 'react'
import {
	restrictToFirstScrollableAncestor,
	restrictToParentElement,
} from '@dnd-kit/modifiers'

import { TIME_SLOT_HEIGHT, type TimeslotBounds, TOTAL_HEIGHT } from './helpers'

export const useCustomModifiers = (timeslot: TimeslotBounds) => {
	const customModifiers = useCallback<Modifier>(
		(args) => {
			if (!args.active) return args.transform

			switch (args.active.id) {
				case 'draggable-timeslot':
					return restrictToParentElement(args)

				case 'draggable-timeslot-resize-top': {
					const newTransform = restrictToFirstScrollableAncestor(args)
					const maxTopPosition =
						timeslot.startY + timeslot.height - TIME_SLOT_HEIGHT

					return {
						...newTransform,
						y: Math.max(
							Math.min(newTransform.y, maxTopPosition - timeslot.startY),
							-timeslot.startY,
						),
					}
				}

				case 'draggable-timeslot-resize-bottom': {
					const newTransform = restrictToFirstScrollableAncestor(args)
					const currentBottom = timeslot.startY + timeslot.height

					return {
						...newTransform,
						y: Math.min(newTransform.y, TOTAL_HEIGHT - currentBottom),
					}
				}

				default:
					return args.transform
			}
		},
		[timeslot],
	)

	return customModifiers
}
